export default __webpack_public_path__ + "static/media/logo.623e883c.svg";